import React, { useState, useEffect, useRef } from "react";
import "./Council.css"; 

function Council() {
  const [inView, setInView] = useState(false);
  const councilSectionRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (councilSectionRef.current) {
        const rect = councilSectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setInView(true);
          setTimeout(() => {
            if (councilSectionRef.current) {
              councilSectionRef.current.classList.add("done");
            }
          }, 2000);
        } else {
          setInView(false);
          if (councilSectionRef.current) {
            councilSectionRef.current.classList.remove("done");
          }
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className="the-council">
      <section className="section-council" ref={councilSectionRef}>
      <div className="sectiontop-line"></div>
      <h2 className="sectiontitle">THE COUNCIL</h2>
      <div className="sectionbottom-line"></div>
      </section>
      <div className={`the-council animate-up ${inView ? "in-view" : ""}`}
    ref={councilSectionRef}>
        <main className="content">
            <p>
            The ASG Council, among other things, has the responsibility to set broad organisational 
            policies for the Society. This includes reviewing and approving strategic efforts 
            that impact both industry and public interest within the financial 
            service sectors.
            </p>
        </main>
      </div>


 
      <section className="image-container">
        <div>
        <div className="council-image" style={{ 
            background: `url(${require('../images/Tagoe.jpg')}) repeat-x`, 
            backgroundSize: 'cover' 
            }}>
        </div>
        <h1>Neil A. Tagoe</h1>
        </div>
        <div>
        <div className="council-image" style={{ 
            background: `url(${require('../images/Prof.jpg')}) repeat-x`, 
            backgroundSize: 'cover' 
            }}>
        </div>
          <h1>Stephen A. Yeboah</h1>
        </div>
        <div>
          <div className="council-image" style={{ 
              background: `url(${require('../images/Ernest.jpg')}) repeat-x`, 
              backgroundSize: 'cover' 
              }}>
          </div>
          <h1>Ernest A. Vondee</h1>
        </div>
        <div>
          <div className="council-image" style={{ 
              background: `url(${require('../images/Frank.jpg')}) repeat-x`, 
              backgroundSize: 'cover' 
              }}>
          </div>
          <h1>Dr. Frank A. Odoom</h1>
        </div>
      </section>
           <section className="image-container">
        <div>
        <div className="council-image" style={{ 
            background: `url(${require('../images/kofi.jpg')}) repeat-x`, 
            backgroundSize: 'cover' 
            }}>
        </div>
        <h1>Kofi Ntim</h1>
        </div>
        <div>
        <div className="council-image" style={{ 
            background: `url(${require('../images/Kakra.jpg')}) repeat-x`, 
            backgroundSize: 'cover' 
            }}>
        </div>
          <h1>Kakra D. Nyarko</h1>
        </div>
        <div>
          <div className="council-image" style={{ 
              background: `url(${require('../images/Magnus.jpg')}) repeat-x`, 
              backgroundSize: 'cover' 
              }}>
          </div>
          <h1>Magnus O. Agyemang</h1>
        </div>
        <div>
          <div className="council-image" style={{ 
              background: `url(${require('../images/Haris.jpg')}) repeat-x`, 
              backgroundSize: 'cover' 
              }}>
          </div>
          <h1>Haris O. Yemoh</h1>
        </div>
      </section>
      <section className="image-container">
        <div>
        <div className="council-image" style={{ 
            background: `url(${require('../images/Mark.jpg')}) repeat-x`, 
            backgroundSize: 'cover' 
            }}>
        </div>
        <h1>Mark L. Henaku</h1>
        </div>
      </section>
    </div>
  );
}

export default Council;
